<template>
  <div class="splide">
    <div class="splide__track">
      <ul class="splide__list">
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script>
import '@splidejs/splide/dist/css/splide-core.min.css';

export default {
  name: 'Slider',
  mounted() {
    this.$emit('mounted');
  },
};
</script>
